module.exports = __webpack_public_path__ + "img/q1-priest.ee203ab6.svg";